import { KeyIcon, LockClosedIcon } from '@heroicons/react/24/solid'
import React, { useCallback, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { Fade } from 'react-reveal'
import { Link, useHistory } from 'react-router-dom'
import { api } from '../api'
import FormBtn from '../components/elements/Buttons/FormBtn'
import GoBackBtn from '../components/elements/Buttons/GoBackBtn'
import { FormCardInput } from '../components/FormCard'
import ToastAction from '../components/ToastAction'
import SaraRecovery from '../images/sara @.png'

export default function ResetPassword() {
  const { register, handleSubmit, formState: { errors } } = useForm()
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    if (!sessionStorage.getItem('email_recovery')) history.push('/login')
  }, [])

  const _recovery = useCallback(async data => {
    if (data.password !== data.confirm_password) return toast.custom((t) => <ToastAction saraExpression="thinking" toastRef={t} label="Les mots de passe ne sont pas identiques." description="Assurez-vous que vos mots de passe sont parfaitement identiques." />)
    const email_recovery = sessionStorage.getItem('email_recovery')
    try {
      setLoading(true)
      await api.auth().recoveryPassword(email_recovery, data.code, data.password)
      setLoading(false)
      sessionStorage.removeItem('email_recovery')
      history.push('/login')
    } catch (error) {
      setLoading(false)
      if ('CodeMismatchException' == error.code) return toast.custom((t) => <ToastAction saraExpression="thinking" toastRef={t} label="Le code saisi est incorrect" description={`Veuillez saisir le code reçu à l'adresse ${email_recovery}.`} />)
      if ('InvalidPasswordException' == error.code) return toast.custom((t) => <ToastAction saraExpression="thinking" toastRef={t} label="Votre mot de passe n'est pas valide." description="Pour assurer la sécurité de votre compte, veuillez respecter les critères de sécuruté de mot de passe SVP !" />)
      toast.custom((t) => <ToastAction saraExpression="sorry" toastRef={t} label="Oups !!" description="Nous avons rencontré un problème. Veuillez réessayer SVP." />)
    }
  }, [])
  return (
    <div className='min-h-screen bg-gray-50 flex items-center justify-center p-4 relative'>
      <GoBackBtn />
      <Fade right>
        <section className='flex flex-col items-center w-[500px] space-y-10'>
          <div className='flex flex-col items-center space-y-2'>
            <img src={SaraRecovery} className="h-64 transform translate-x-8 -mb-8" />
            <h1 className="text-gray-600 font-bold text-2xl">Réinitialisation du mot de passe</h1>
            <p className="text-center text-gray-500 w-[300px]">Créer un nouveau mot de passe pour accéder à votre compte <b>Azatys.</b></p>
          </div>

          <form onSubmit={handleSubmit(_recovery)} className="w-full space-y-4">
            <FormCardInput
              autoFocus
              type='number'
              placeholder='Code'
              name='code'
              rules={{ required: true, min: 0, pattern: /^[0-9]{6}$/im }}
              register={register}
              errorType={errors?.code?.type}
              icon={<KeyIcon className="h-4 text-gray-500" />}
            />
            <FormCardInput
              type='password'
              placeholder='Nouveau mot de passe'
              name='password'
              register={register}
              errorType={errors?.password?.type}
              icon={<LockClosedIcon className="h-4 text-gray-500" />}
            />
            <p className="text-xs text-gray-600 ml-2">
              Pour que votre mot de passe soit valide, il doit au moins:
              <ul className='list-disc ml-4'>
                <li>Contenir une <b>minuscule</b>, une <b>majuscule</b>, un <b>chiffre</b> et un <b>caractère spécial</b></li>
                <li>Avoir au minimum <b>8 caractères.</b></li>
              </ul>
            </p>
            <FormCardInput
              type='password'
              placeholder='Confirmation du mot de passe'
              name='confirm_password'
              register={register}
              errorType={errors?.confirm_password?.type}
              icon={<LockClosedIcon className="h-4 text-gray-500" />}
            />
            <div className="pt-8">
              <FormBtn disabled={loading} label={loading ? 'Réinitialisation...' : 'Envoyer'} />
              <p className='text-xs text-center text-gray-500 font-medium'>Vous avez déjà un compte ? <Link to="/login" className='text-teal-700 underline font-bold'>Connectez-vous</Link></p>
            </div>
          </form>
        </section>
      </Fade>
    </div>
  )
}